import { Typography } from '@shared/ui/typography/typography';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { AllAdd } from '@vtbhome/juicyfront/indexIcon';
import React, { useEffect } from 'react';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { DeclineEmployeeRequestProps } from './types';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { CACHE_KEY_REQUEST_CREATE } from '@features/request/decline-manager-request/config/api-constants';
import dayjs from 'dayjs';
import { useCreateRequestForNewEmployeeInOrderMutation } from '../api/create-employee-request-in-order-api';
import { useOrderSharedQuery } from '@entities/order/libs/hooks/use-order-shared-query/use-order-shared-query';
import { ButtonWrapper } from './create-employee-request-in-order.styles';
import { RequestStatus } from '@shared/model/request';

export const CreateEmployeeRequestInOrder: React.FC<DeclineEmployeeRequestProps> = ({
    user,
    order,
    isAlreadyExist,
    onAddUser,
}) => {
    const [createRequest, createRequestResult] = useCreateRequestForNewEmployeeInOrderMutation({
        fixedCacheKey: `${CACHE_KEY_REQUEST_CREATE}_${user.id}`,
    });
    const [, , resetOrder] = useOrderSharedQuery(order.id);

    const handleAdd = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();

        const nowDate = dayjs().format('YYYY-MM-DDTHH:mm:ssZ[Z]');
        onAddUser();
        await createRequest({
            body: {
                userId: user.id,
                quantity: 1,
                productId: order.product.id,
            },
            optimisticData: {
                id: Math.random(),
                quantity: 1,
                companyId: user.company?.id || 0,
                status: RequestStatus.OrderForming,
                comment: null,
                createdAt: nowDate,
                updatedAt: nowDate,
                product: { ...order.product },
                initiator: { ...user },
                user: { ...user },
                order: { ...order },
            },
        });
        resetOrder();
    };

    useEffect(() => {
        if (createRequestResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не добавить пользователя к сделке.\n${getQueryError(createRequestResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createRequestResult.reset();
        }
    }, [createRequestResult.isError]);

    return (
        <Tooltip>
            <ButtonWrapper disabled={isAlreadyExist}>
                <Button
                    disabled={isAlreadyExist}
                    buttonType='secondary'
                    size='s'
                    startAdornment={<AllAdd />}
                    onClick={handleAdd}
                />
            </ButtonWrapper>
            <Typography size='body2_short'>{isAlreadyExist ? 'Пользователь уже добавлен' : 'Добавить'}</Typography>
        </Tooltip>
    );
};
